import {Pipe, PipeTransform} from '@angular/core';
import {PaymentMulti} from "../../generated/sales-terminal-client";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: PaymentMulti[] = []) {
    return value.map(item => {
      return this.translateService.instant('general.api_cart_' + item.type);
    }).join(', ');
  }
}
